<ng-container *ngIf="formOnly"><ng-template [ngTemplateOutlet]="rigDetailsFormTemplate"></ng-template></ng-container
><ng-template #rigDetailsFormTemplate
    ><form data-cy="rigDetailsFormQuick" [formGroup]="rigDetailsForm">
        <div class="form-floating mb-3">
            <sbf-input-select data-cy="vehicleUseSelect" idAppend="vehicleUse" formControlName="vehicleUse" defaultText="Vehicle Use" [optionsRecordsArray]="[vehicleUseText]" [class.is-invalid]="vehicleUseControlInvalid"></sbf-input-select>
            <div class="invalid-feedback" *ngIf='vehicleUseControl.hasError("required")'>Vehicle Use required.</div>
        </div>
    </form></ng-template
>
